const DB_NAME = 'strategos-offline';
const DB_VERSION = 1;
const PHOTOS = 'photoQueue';
const PASSPORTS = 'passportCache';

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(PHOTOS)) {
        const st = db.createObjectStore(PHOTOS, { keyPath: 'id' });
        st.createIndex('registrationId', 'registrationId', { unique: false });
      }
      if (!db.objectStoreNames.contains(PASSPORTS)) db.createObjectStore(PASSPORTS, { keyPath: 'registrationId' });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(store, mode, fn) {
  return openDb().then((db) => new Promise((resolve, reject) => {
    const t = db.transaction(store, mode);
    const req = fn(t.objectStore(store));
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  }));
}

export const offlineQueue = {
  async enqueuePhoto({ registrationId, waypointId, waypointName, file }) {
    const item = {
      id: `${registrationId}:${waypointId}:${Date.now()}`,
      registrationId, waypointId, waypointName,
      blob: file, fileName: file.name || 'foto.jpg', mimeType: file.type || 'image/jpeg',
      createdAt: new Date().toISOString(), attempts: 0, lastError: null,
    };
    await tx(PHOTOS, 'readwrite', (s) => s.put(item));
    return item;
  },
  async list(registrationId) {
    const all = await tx(PHOTOS, 'readonly', (s) => (registrationId ? s.index('registrationId').getAll(registrationId) : s.getAll()));
    return (all || []).sort((a, b) => a.createdAt.localeCompare(b.createdAt));
  },
  remove(id) { return tx(PHOTOS, 'readwrite', (s) => s.delete(id)); },
  update(item) { return tx(PHOTOS, 'readwrite', (s) => s.put(item)); },
  cachePassport(registrationId, data) {
    return tx(PASSPORTS, 'readwrite', (s) => s.put({ registrationId, data, cachedAt: new Date().toISOString() })).catch(() => {});
  },
  getPassport(registrationId) { return tx(PASSPORTS, 'readonly', (s) => s.get(registrationId)).catch(() => null); },
};

export const isNetworkError = (e) => !e?.response || e.code === 'ERR_NETWORK' || e.message === 'Network Error';
